export const isAuthenticationFailure = (response, error) => {
    const responseData = (response || error?.response)?.data || {};
    const message = String(responseData.message || responseData.error || '').toLowerCase();
    const version = String(responseData.version || '').trim().toUpperCase();

    return response?.status === 401 || error?.response?.status === 401 ||
        version === 'NA' || message.includes('unauth') || message.includes('unauthor');
};
